import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {ResultRootState as RootState} from '../../interfaces'
import abTest from '../../slices/abTest'
import aitems from '../../slices/aitems'
import banner from '../../slices/banner'
import common from '../../slices/common'
import deliveryManager from '../../slices/deliveryManager'
import purchaser from '../../slices/purchaser'
import recommendationProduct from '../../slices/recommendationProduct'
import result from '../../slices/result'
import reward from '../../slices/reward'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        abTest,
        aitems,
        banner,
        common,
        deliveryManager,
        purchaser,
        recommendationProduct,
        result,
        reward,
        router: routerReducer,
    })

export default createRootReducer
